<app-request-payment [invoice]="invoice" (paymentRequestSent)="dialogRef.close()" (paymentRequestSendCancelled)="dialogRef.close()" [contextIdDto]="contextIdDto" [eventBus]="eventBus" [visible]="true"></app-request-payment>

